import { render } from "./SalesListMix.vue?vue&type=template&id=2e5376fe"
import script from "./SalesListMix.vue?vue&type=script&lang=js"
export * from "./SalesListMix.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__